// extracted by mini-css-extract-plugin
export default {"pageArea":"VisualizationHome_pageArea__1G5Pa","fullWidth":"VisualizationHome_fullWidth__NHSan","hidden":"VisualizationHome_hidden__YA3CX"};